import { useQuery, UseQueryOptions } from 'react-query';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';

export const useGetPublicApplication = (
  applicationUuid: string,
  options?: UseQueryOptions<
    PublicApplication,
    unknown,
    PublicApplication,
    string[]
  >
) => {
  const publicApplicationOptions = {
    queryKey: ['publicApplication', applicationUuid],
    queryFn: async () => {
      return await PublicApplicationAPI.getPublicApplication(applicationUuid);
    },
    enabled: !!applicationUuid,
    ...options,
  };
  const { data, isLoading, error, refetch } = useQuery(
    publicApplicationOptions
  );

  return {
    data,
    isLoading,
    error,
    publicApplicationOptions,
    refetch,
  };
};
